module.exports = __webpack_public_path__ + "img/arctic-circle-logo.2c3d064a.svg";